import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { clickedCardEvent } from '../../../Utils/CategoryPageUtils';
import { removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { harcodedTextFlagData } from '../../CategoryDetail/CategoryProductTags/constant';
import { ProductFlag } from '../../CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import { Rating } from '../../StoreHomePage/ProductCard/styled';
import AddToCartCta from './AddToCartCta';
import {
  ProductNewImage,
  ProductNewImageSection,
  ProductNewMainSection,
  ProductNewSectionTitle,
  VariantName,
} from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';
import ProductPriceAB from '../../../Utils/ProductPriceAB';

export default function ProductCardNew(props) {
  const {
    data,
    storeHome,
    setAddedToCart,
    section,
    key,
    category_name,
    searchallProduct,
    id,
    maxWidth,
    mobileWidth,
    shrink,
    article,
    showPrice,
    notFireEvent,
    parentTag,
    rupeeSymbol,
    fromBabyNames,
    hideAddToCart,
    query_add = {},
  } = props;
  const router = useRouter();
  const ratingString = data?.starRatingSubScript;
  const ratingText =
    (ratingString?.slice(0, ratingString.length - 1) || data?.ratingCount) +
    ' Ratings)';
  const ratingCountString = `(${data?.ratingCount} Ratings)`;
  const strikePrice = data?.strikePrice || data?.strike_price;
  const productName = data?.name || data?.title;
  const [cardEffect, setCardEffect] = useState('');

  const cardClickHandler = () => {
    let url = data?.webUrl + window?.location?.search;
    if (!notFireEvent) {
      clickedCardEvent(section, data, category_name, url, fromBabyNames);
    }
  };

  const custom_query = { ...router.query, ...query_add };
  const productFlagData = data?.textFlag || harcodedTextFlagData;

  return (
    <ProductNewMainSection
      className={`hoverable_section ${cardEffect}`}
      id={id}
      maxWidth={maxWidth}
      mobileWidth={mobileWidth}
      shrink={shrink}
      article={article}
      storeHome={storeHome}
      hideAddToCart={hideAddToCart}
    >
      <div className="animated_card">
        <div onClick={cardClickHandler}>
          <Link
            href={{
              pathname: data?.webUrl || data?.web_url,
              query: removeDefaultParams(custom_query),
            }}
            passHref
            locale={false}
            onClick={(e) => {
              e.preventDefault();
              setCardEffect('lowOpacity');
              const { addParams, newUrl } = queryParamHandling(
                data?.webUrl || data?.web_url,
                custom_query,
              );
              setTimeout(() => {
                router.push(newUrl + addParams, '', {
                  locale: getRouterLocale(router),
                });
              }, [200]);
            }}
          >
            <ProductNewImageSection>
              {productFlagData?.text?.length > 0 && (
                <ProductFlag flagData={productFlagData}>
                  {productFlagData?.text}
                  <span></span>
                </ProductFlag>
              )}
              <ProductNewImage
                src={data?.image}
                srcSet={`${data?.image}?tr=w-400 1x,${data?.image}?tr=w-400 2x,${data?.image}?tr=w-600 3x,${data?.image}?tr=w-800 4x`}
                loading="lazy"
                alt={productName}
              />
            </ProductNewImageSection>
            <ProductNewSectionTitle>{productName}</ProductNewSectionTitle>
            <VariantName perUnit={true}>
              {data?.variantType?.length ? `${data?.variantType}` : ''}
            </VariantName>
            {/* <span className="mainPrice">
                                {rupeeSymbol
                                    ? `₹${data?.price}`
                                    : data?.price}
                            </span> */}
            <ProductPriceAB
              priceData={data}
              classString="mainPrice"
              classStringStrike="strikePriceCat"
              classStringDisc="discountCat"
              noGap={true}
              paddingTop={true}
            />
            {/* <span className="strikePrice">
                            {rupeeSymbol ? `₹${strikePrice}` : strikePrice}
                        </span>
                        <span className="discount">{data?.discount}</span> */}
            {data?.starRating > 0 && (
              <Rating category>
                <span>{data?.starRating}</span>
                <img
                  src={images.filledStar}
                  alt="filledStar"
                  title="filledStar"
                />
                <span className="total_ratingnumber">
                  {ratingString ? ratingText : ratingCountString}
                </span>
              </Rating>
            )}
          </Link>
        </div>
        {!hideAddToCart ? (
          <AddToCartCta
            key={key}
            product={data}
            section={section}
            category_name={category_name}
            setAddedToCart={setAddedToCart}
            parentTag={parentTag}
            aplusplus={true}
          />
        ) : null}
      </div>
    </ProductNewMainSection>
  );
}
